import { render, staticRenderFns } from "./el-link.vue?vue&type=template&id=7f148ce2&scoped=true&"
import script from "./el-link.vue?vue&type=script&lang=js&"
export * from "./el-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f148ce2",
  null
  
)

export default component.exports